// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_TvDashboardResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/tv_dashboard
 *
 * The in-store TV deadline board groups pending service items by their
 * `days_until_due` relative to today (computed in the source model query):
 *   - overdue  : days_until_due < 0
 *   - today    : days_until_due == 0
 *   - tomorrow : days_until_due == 1
 *   - upcoming : days_until_due > 1
 */
import type { Orders_TvDashboardRow } from './Orders_TvDashboardRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_TvDashboardResponseDados {
overdue: Orders_TvDashboardRow[]
today: Orders_TvDashboardRow[]
tomorrow: Orders_TvDashboardRow[]
upcoming: Orders_TvDashboardRow[]
}

export type Orders_TvDashboardResponse = ApiResponse<Orders_TvDashboardResponseDados>;

registerResponseContract('Orders_TvDashboardResponse', {
  overdue: {
    type: 'array',
    required: true,
    items: {
      so_order_item_id:                   { type: 'number',  required: true },
      so_order_id:                        { type: 'number',  required: true },
      so_order_item_qrcode:               { type: 'string',  required: false },
      so_order_item_expected_delivery_at: { type: 'string',  required: false },
      so_order_item_franchise_id:         { type: 'number',  required: true },
      so_order_client_id:                 { type: 'number',  required: false },
      cliente_nome:                       { type: 'string',  required: true },
      so_service_name:                    { type: 'string',  required: true },
      so_priority_name:                   { type: 'string',  required: false },
      so_order_item_deadline_days:        { type: 'number',  required: false },
      so_order_item_ready_at:             { type: 'string',  required: false },
      days_until_due:                     { type: 'number',  required: false },
    },
  },
  today: {
    type: 'array',
    required: true,
    items: {
      so_order_item_id:                   { type: 'number',  required: true },
      so_order_id:                        { type: 'number',  required: true },
      so_order_item_qrcode:               { type: 'string',  required: false },
      so_order_item_expected_delivery_at: { type: 'string',  required: false },
      so_order_item_franchise_id:         { type: 'number',  required: true },
      so_order_client_id:                 { type: 'number',  required: false },
      cliente_nome:                       { type: 'string',  required: true },
      so_service_name:                    { type: 'string',  required: true },
      so_priority_name:                   { type: 'string',  required: false },
      so_order_item_deadline_days:        { type: 'number',  required: false },
      so_order_item_ready_at:             { type: 'string',  required: false },
      days_until_due:                     { type: 'number',  required: false },
    },
  },
  tomorrow: {
    type: 'array',
    required: true,
    items: {
      so_order_item_id:                   { type: 'number',  required: true },
      so_order_id:                        { type: 'number',  required: true },
      so_order_item_qrcode:               { type: 'string',  required: false },
      so_order_item_expected_delivery_at: { type: 'string',  required: false },
      so_order_item_franchise_id:         { type: 'number',  required: true },
      so_order_client_id:                 { type: 'number',  required: false },
      cliente_nome:                       { type: 'string',  required: true },
      so_service_name:                    { type: 'string',  required: true },
      so_priority_name:                   { type: 'string',  required: false },
      so_order_item_deadline_days:        { type: 'number',  required: false },
      so_order_item_ready_at:             { type: 'string',  required: false },
      days_until_due:                     { type: 'number',  required: false },
    },
  },
  upcoming: {
    type: 'array',
    required: true,
    items: {
      so_order_item_id:                   { type: 'number',  required: true },
      so_order_id:                        { type: 'number',  required: true },
      so_order_item_qrcode:               { type: 'string',  required: false },
      so_order_item_expected_delivery_at: { type: 'string',  required: false },
      so_order_item_franchise_id:         { type: 'number',  required: true },
      so_order_client_id:                 { type: 'number',  required: false },
      cliente_nome:                       { type: 'string',  required: true },
      so_service_name:                    { type: 'string',  required: true },
      so_priority_name:                   { type: 'string',  required: false },
      so_order_item_deadline_days:        { type: 'number',  required: false },
      so_order_item_ready_at:             { type: 'string',  required: false },
      days_until_due:                     { type: 'number',  required: false },
    },
  },
})
